/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface StatusChallengeStats
 */
export interface StatusChallengeStats {
    /**
     * The number of reservations since the start of the status challenge.
     * @type {number}
     * @memberof StatusChallengeStats
     */
    statusChallengeReservations?: number;
    /**
     * The number of nights stayed in Gondola bookings since the start of the status challenge.
     * @type {number}
     * @memberof StatusChallengeStats
     */
    statusChallengeNights?: number;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof StatusChallengeStats
     */
    statusChallengeSpend?: CurrencyAmount;
}

/**
 * Check if a given object implements the StatusChallengeStats interface.
 */
export function instanceOfStatusChallengeStats(value: object): value is StatusChallengeStats {
    return true;
}

export function StatusChallengeStatsFromJSON(json: any): StatusChallengeStats {
    return StatusChallengeStatsFromJSONTyped(json, false);
}

export function StatusChallengeStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusChallengeStats {
    if (json == null) {
        return json;
    }
    return {
        
        'statusChallengeReservations': json['status_challenge_reservations'] == null ? undefined : json['status_challenge_reservations'],
        'statusChallengeNights': json['status_challenge_nights'] == null ? undefined : json['status_challenge_nights'],
        'statusChallengeSpend': json['status_challenge_spend'] == null ? undefined : CurrencyAmountFromJSON(json['status_challenge_spend']),
    };
}

export function StatusChallengeStatsToJSON(json: any): StatusChallengeStats {
    return StatusChallengeStatsToJSONTyped(json, false);
}

export function StatusChallengeStatsToJSONTyped(value?: StatusChallengeStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_challenge_reservations': value['statusChallengeReservations'],
        'status_challenge_nights': value['statusChallengeNights'],
        'status_challenge_spend': CurrencyAmountToJSON(value['statusChallengeSpend']),
    };
}

